import React, { createContext, useContext, useState } from 'react';

export const AlertContext = createContext();

export function useAlert() {
  return useContext(AlertContext);
}

export function AlertProvider({ children }) {
  const [alert, setAlert] = useState(null);

  const showAlert = (message, type = 'info') => {
    setAlert({ message, type });

    // auto-hide after 3 seconds
    setTimeout(() => setAlert(null), 3000);
  };

  const renderEmoji = (type) => {
    switch (type) {
      case 'success':
        return '✅'; // Added
      case 'warning':
        return '❌'; // Removed
      case 'error':
        return '⚠️'; // Generic error
      default:
        return 'ℹ️'; // Info
    }
  };

  return (
    <AlertContext.Provider value={{ showAlert }}>
      {children}
      {alert && (
        <div
          className={`alert alert-${alert.type} `}
          role="alert"
          style={{ zIndex: 1050 }}
        >
          <span style={{ fontSize: '1.2rem', marginRight: '0.5rem' }}>
            {renderEmoji(alert.type)}
          </span>
          <span>{alert.message}</span>
        </div>
      )}
    </AlertContext.Provider>
  );
}
